import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Users } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';

export const GuestSignupNudge = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const signUp = async () => { await logout(); navigate('/?signup=1'); };
    return (
        <div className="rounded-2xl border border-primary/20 bg-primary/5 p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-testid="guest-signup-nudge">
            <div className="flex gap-3">
                <Users className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <div>
                    <p className="font-semibold">Like what you see?</p>
                    <p className="text-sm text-muted-foreground">Start your own group free, or join one with an invite code.</p>
                </div>
            </div>
            <Button onClick={signUp} className="rounded-full shrink-0" data-testid="guest-nudge-signup-btn">
                Sign up free <ArrowRight className="w-4 h-4 ml-1.5" />
            </Button>
        </div>
    );
};

export default GuestSignupNudge;
